// extracted by mini-css-extract-plugin
export default {"underlined":"style_underlined__sX-N5","highlighted":"style_highlighted__tO36p"};